import { useState } from "react"

/** Equal by content, for drafts holding objects (texts per language). */
export const sameContent = <T>(a: T, b: T) =>
  JSON.stringify(a) === JSON.stringify(b)

/**
 * A field's draft that follows its saved value for as long as it has no
 * edits. Saved settings can change under an open page (the AI assistant
 * saves one, or a refetch brings another admin's change): an untouched field
 * then shows the new value, instead of putting the old one back on the next
 * Save. A field with edits keeps them.
 */
export function useSavedDraft<T>(
  saved: T,
  same: (a: T, b: T) => boolean = Object.is,
): [T, (next: T) => void] {
  const [draft, setDraft] = useState(saved)
  const [base, setBase] = useState(saved)
  // Adjusting state while rendering, as React recommends for state that
  // follows a prop: no extra render with the stale value.
  if (!same(base, saved)) {
    setBase(saved)
    if (same(draft, base)) setDraft(saved)
  }
  return [draft, setDraft]
}
